"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItems = exports.getState = void 0;

var getState = function getState(store) {
  return store.CategoryTopBannerBuilderComponent;
};

exports.getState = getState;

var getItemsState = function getItemsState(store) {
  return getState(store) && getState(store).items ? getState(store).items : [];
};

var getItemById = function getItemById(store, id) {
  return getState(store) && getState(store).itemsById ? getState(store).itemsById[id] : null;
};

var getItems = function getItems(store) {
  return getItemsState(store).map(function (id) {
    return getItemById(store, id);
  });
};

exports.getItems = getItems;